/**
 * Computes the active CSS rotation (in degrees) of the force-landscape video so
 * touch coordinates can be un-rotated before normalization.
 *
 * Uses the same resolved `forceRotateDeg` (90 or -90) that drives the
 * `--force-rotate-angle` CSS var (see forceRotate.ts / responsiveHooks.ts), so
 * visual rotation and touch mapping never disagree — including when the
 * accelerometer flips the direction for the opposite landscape hold. Returns 0
 * when the video is not force-rotated (desktop, or non-force-rotated
 * fullscreen-landscape) so the caller keeps the plain rect-based mapping.
 *
 * @param isVisuallyRotated - True when the force-landscape rotation is applied.
 * @param forceRotateDeg    - Resolved rotation direction from the orientation store (90 or -90).
 */
export const computeTouchRotationDeg = (isVisuallyRotated: boolean, forceRotateDeg: number): number => {
  if (!isVisuallyRotated) return 0;
  return forceRotateDeg;
};
